export { GalaxyTooltipDirective as GalaxyTooltip } from './src/directive/tooltip.directive';
export { TooltipComponent } from './src/tooltip.component';
export * from './src/tooltip.module';
